import { useForm } from 'react-hook-form';
import { UseSendContactEmail } from '../services/Query';
import { Modal, Spinner } from 'flowbite-react';
import { useState } from 'react';

type IContactProps = {
  firstName: string;
  lastName: string;
  email: string;
  phone_number: string;
  subject: string;
  message: string;
};

export const Contact = () => {
  const [showMessage, setShowMessage] = useState(false);
  const {
    register,
    getValues,
    reset,
    watch,
    formState: { isValid },
  } = useForm<IContactProps>({
    mode: 'onChange',
  });
  const { mutate: sendContactEmail, isLoading: isSending } =
    UseSendContactEmail();
  const onSendContactEmail = () => {
    const data = getValues();
    sendContactEmail(JSON.stringify(data), {
      onSuccess: () => {
        setShowMessage(true);
      },
      onError: () => {},
    });
  };
  return (
    <div className="py-8 space-y-8 font-nunito">
      <section className="">
        <h6 className="text-center font-bold text-[#0098DB] text-3xl xl:text-[40px]">
          Contact Us
        </h6>
        <div className="text-[#3F3D56] text-center">
          Any question or remarks? Just write us a message.
        </div>
      </section>
      <section className="flex flex-col justify-center md:flex-row md:space-x-5 md:px-4">
        <div className="md:w-[45vw] xl:w-[490px] rounded-md bg-[#66B929] p-8 text-white grid place-content-between md:min-h-[600px] w-[95vw] max-md:mx-auto">
          <div className="space-y-4">
            <div className="text-[28px] font-bold">Contact Information</div>
            <div>Please leave a message</div>
          </div>
          <div className="space-y-8">
            <div className="flex space-x-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.0002 10.999H22.0002C22.0002 5.869 18.1272 2 12.9902 2V4C17.0522 4 20.0002 6.943 20.0002 10.999Z"
                  fill="white"
                />
                <path
                  d="M12.9998 8.00024C15.1028 8.00024 15.9998 8.89724 15.9998 11.0002H17.9998C17.9998 7.77524 16.2248 6.00024 12.9998 6.00024V8.00024ZM16.4218 13.4432C16.2296 13.2686 15.9771 13.1754 15.7176 13.1835C15.4581 13.1915 15.2118 13.3001 15.0308 13.4862L12.6378 15.9472C12.0618 15.8372 10.9038 15.4762 9.71179 14.2872C8.51979 13.0942 8.15879 11.9332 8.05179 11.3612L10.5108 8.96724C10.6972 8.78637 10.8059 8.54006 10.814 8.28045C10.822 8.02083 10.7287 7.76828 10.5538 7.57624L6.85879 3.51324C6.68384 3.3206 6.44067 3.20374 6.18095 3.1875C5.92122 3.17125 5.66539 3.2569 5.46779 3.42624L3.29779 5.28724C3.1249 5.46075 3.02171 5.69169 3.00779 5.93624C2.99279 6.18624 2.70679 12.1082 7.29879 16.7022C11.3048 20.7072 16.3228 21.0002 17.7048 21.0002C17.9068 21.0002 18.0308 20.9942 18.0638 20.9922C18.3083 20.9786 18.5391 20.8749 18.7118 20.7012L20.5718 18.5302C20.7413 18.3328 20.8271 18.077 20.811 17.8173C20.795 17.5576 20.6783 17.3143 20.4858 17.1392L16.4218 13.4432Z"
                  fill="white"
                />
              </svg>
              <div>+1 234 567 8910</div>
            </div>
            <div className="flex space-x-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 1.5C9.81276 1.50258 7.71584 2.3726 6.16923 3.91922C4.62261 5.46584 3.75259 7.56276 3.75001 9.75C3.74739 11.5374 4.33124 13.2763 5.41201 14.7C5.41201 14.7 5.63701 14.9963 5.67376 15.039L12 22.5L18.3293 15.0353C18.3623 14.9955 18.588 14.7 18.588 14.7L18.5888 14.6978C19.669 13.2747 20.2526 11.5366 20.25 9.75C20.2474 7.56276 19.3774 5.46584 17.8308 3.91922C16.2842 2.3726 14.1873 1.50258 12 1.5ZM12 12.75C11.4067 12.75 10.8266 12.5741 10.3333 12.2444C9.83995 11.9148 9.45543 11.4462 9.22837 10.8981C9.00131 10.3499 8.9419 9.74667 9.05765 9.16473C9.17341 8.58279 9.45913 8.04824 9.87869 7.62868C10.2982 7.20912 10.8328 6.9234 11.4147 6.80764C11.9967 6.69189 12.5999 6.7513 13.1481 6.97836C13.6962 7.20542 14.1648 7.58994 14.4944 8.08329C14.8241 8.57664 15 9.15666 15 9.75C14.999 10.5453 14.6826 11.3078 14.1202 11.8702C13.5578 12.4326 12.7954 12.749 12 12.75Z"
                  fill="white"
                />
              </svg>

              <div>demo@gmail.com</div>
            </div>
            <div className="flex space-x-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 4H2V20H22V4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                  fill="white"
                />
              </svg>
              <div>
                132 Apple Street Boston, Massachusetts 02156 United States
              </div>
            </div>
          </div>
          <div className="flex space-x-4">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="15" r="15" fill="#0098DB" />
              <g clipPath="url(#clip0_882_33827)">
                <path
                  d="M17.5237 13.7813L23.4811 7H22.0699L16.8949 12.8869L12.7648 7H8L14.2469 15.9029L8 23.0133H9.4112L14.8725 16.7952L19.2352 23.0133H24M9.92053 8.04213H12.0885L22.0688 22.0224H19.9003"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_882_33827">
                  <rect
                    width="16"
                    height="16.0134"
                    fill="white"
                    transform="translate(8 7)"
                  />
                </clipPath>
              </defs>
            </svg>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="15" cy="15" r="15" fill="#0098DB" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7018 7.048C12.5549 7.00873 12.8269 7 15 7C17.1731 7 17.4451 7.00945 18.2975 7.048C19.1498 7.08655 19.7316 7.22255 20.2407 7.41964C20.7738 7.62109 21.2575 7.936 21.6575 8.34327C22.0647 8.74255 22.3789 9.22545 22.5796 9.75927C22.7775 10.2684 22.9127 10.8502 22.952 11.7011C22.9913 12.5556 23 12.8276 23 15C23 17.1731 22.9905 17.4451 22.952 18.2982C22.9135 19.1491 22.7775 19.7309 22.5796 20.24C22.3789 20.7739 22.0642 21.2576 21.6575 21.6575C21.2575 22.0647 20.7738 22.3789 20.2407 22.5796C19.7316 22.7775 19.1498 22.9127 18.2989 22.952C17.4451 22.9913 17.1731 23 15 23C12.8269 23 12.5549 22.9905 11.7018 22.952C10.8509 22.9135 10.2691 22.7775 9.76 22.5796C9.22612 22.3789 8.74241 22.0642 8.34255 21.6575C7.93555 21.2579 7.62059 20.7745 7.41964 20.2407C7.22255 19.7316 7.08727 19.1498 7.048 18.2989C7.00873 17.4444 7 17.1724 7 15C7 12.8269 7.00945 12.5549 7.048 11.7025C7.08655 10.8502 7.22255 10.2684 7.41964 9.75927C7.62089 9.22551 7.93609 8.74205 8.34327 8.34255C8.74257 7.93564 9.2258 7.62069 9.75927 7.41964C10.2684 7.22255 10.8502 7.08727 11.7011 7.048H11.7018ZM18.2327 8.488C17.3891 8.44945 17.136 8.44145 15 8.44145C12.864 8.44145 12.6109 8.44945 11.7673 8.488C10.9869 8.52364 10.5636 8.65382 10.2815 8.76364C9.90836 8.90909 9.64145 9.08145 9.36145 9.36145C9.09603 9.61967 8.89177 9.93402 8.76364 10.2815C8.65382 10.5636 8.52364 10.9869 8.488 11.7673C8.44945 12.6109 8.44145 12.864 8.44145 15C8.44145 17.136 8.44945 17.3891 8.488 18.2327C8.52364 19.0131 8.65382 19.4364 8.76364 19.7185C8.89164 20.0655 9.096 20.3804 9.36145 20.6385C9.61964 20.904 9.93455 21.1084 10.2815 21.2364C10.5636 21.3462 10.9869 21.4764 11.7673 21.512C12.6109 21.5505 12.8633 21.5585 15 21.5585C17.1367 21.5585 17.3891 21.5505 18.2327 21.512C19.0131 21.4764 19.4364 21.3462 19.7185 21.2364C20.0916 21.0909 20.3585 20.9185 20.6385 20.6385C20.904 20.3804 21.1084 20.0655 21.2364 19.7185C21.3462 19.4364 21.4764 19.0131 21.512 18.2327C21.5505 17.3891 21.5585 17.136 21.5585 15C21.5585 12.864 21.5505 12.6109 21.512 11.7673C21.4764 10.9869 21.3462 10.5636 21.2364 10.2815C21.0909 9.90836 20.9185 9.64145 20.6385 9.36145C20.3803 9.09605 20.066 8.89179 19.7185 8.76364C19.4364 8.65382 19.0131 8.52364 18.2327 8.488ZM13.9782 17.4662C14.5488 17.7037 15.1843 17.7358 15.7759 17.5569C16.3676 17.378 16.8788 16.9992 17.2223 16.4853C17.5657 15.9713 17.72 15.3541 17.6589 14.739C17.5978 14.1239 17.3251 13.5491 16.8873 13.1127C16.6082 12.8338 16.2707 12.6202 15.8992 12.4874C15.5276 12.3545 15.1312 12.3057 14.7385 12.3444C14.3459 12.3832 13.9667 12.5085 13.6282 12.7114C13.2898 12.9142 13.0005 13.1896 12.7813 13.5177C12.5621 13.8458 12.4183 14.2184 12.3604 14.6087C12.3024 14.999 12.3317 15.3973 12.4462 15.7749C12.5607 16.1525 12.7574 16.5001 13.0223 16.7925C13.2872 17.085 13.6137 17.315 13.9782 17.4662ZM12.0924 12.0924C12.4742 11.7105 12.9275 11.4076 13.4264 11.201C13.9253 10.9943 14.46 10.888 15 10.888C15.54 10.888 16.0747 10.9943 16.5736 11.201C17.0725 11.4076 17.5258 11.7105 17.9076 12.0924C18.2895 12.4742 18.5924 12.9275 18.799 13.4264C19.0057 13.9253 19.112 14.46 19.112 15C19.112 15.54 19.0057 16.0747 18.799 16.5736C18.5924 17.0725 18.2895 17.5258 17.9076 17.9076C17.1365 18.6788 16.0906 19.112 15 19.112C13.9094 19.112 12.8635 18.6788 12.0924 17.9076C11.3212 17.1365 10.888 16.0906 10.888 15C10.888 13.9094 11.3212 12.8635 12.0924 12.0924ZM20.024 11.5004C20.1186 11.4111 20.1944 11.3038 20.2468 11.1847C20.2992 11.0656 20.3271 10.9373 20.329 10.8072C20.3309 10.6772 20.3067 10.548 20.2578 10.4275C20.2089 10.307 20.1363 10.1975 20.0443 10.1055C19.9524 10.0135 19.8429 9.94091 19.7223 9.89201C19.6018 9.84311 19.4727 9.81889 19.3426 9.82079C19.2125 9.82268 19.0842 9.85066 18.9651 9.90305C18.8461 9.95545 18.7387 10.0312 18.6495 10.1258C18.4759 10.3098 18.3808 10.5543 18.3845 10.8072C18.3882 11.0602 18.4903 11.3017 18.6692 11.4806C18.8481 11.6595 19.0896 11.7616 19.3426 11.7653C19.5955 11.769 19.84 11.674 20.024 11.5004Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="md:w-[50vw] xl:w-[600px] grid grid-cols-1 md:grid-cols-2 p-6 place-content-center gap-8">
          <div>
            <h6 className="md:text-sm xl:text-base">First Name</h6>
            <div>
              <input
                type="text"
                className="w-full border-0 border-b md:text-sm xl:text-base"
                placeholder="First Name"
                {...register('firstName', { required: true })}
              />
            </div>
          </div>
          <div>
            <h6 className="md:text-sm xl:text-base">Last Name</h6>
            <div>
              <input
                type="text"
                className="w-full border-0 border-b md:text-sm xl:text-base"
                placeholder="Last Name"
                {...register('lastName', { required: true })}
              />
            </div>
          </div>
          <div>
            <h6 className="md:text-sm xl:text-base">Email Address</h6>
            <div>
              <input
                type="text"
                className="w-full border-0 border-b md:text-sm xl:text-base"
                placeholder="Email address"
                {...register('email', { required: true })}
              />
            </div>
          </div>
          <div>
            <h6 className="md:text-sm xl:text-base">Phone Number</h6>
            <div>
              <input
                type="text"
                className="w-full border-0 border-b md:text-sm xl:text-base"
                placeholder="+1 012 3456 789"
                {...register('phone_number', { required: true })}
              />
            </div>
          </div>
          <div className=" md:col-span-2">
            <h6 className="text-[#0098DB] font-bold md:text-sm xl:text-base">
              Select Subject?
            </h6>
            <div className="mt-2">
              <select {...register('subject', { required: true })}>
                <option value="Technical Support">Technical Support</option>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
          <div className=" md:col-span-2">
            <h6 className="md:text-sm xl:text-base">Message</h6>
            <div>
              <textarea
                className="w-full p-4 border-0 border-b"
                rows={3}
                placeholder="Write your message.."
                {...register('message', { required: true })}
              ></textarea>
            </div>
          </div>
          <div className="flex justify-end md:col-span-2">
            <button
              className="px-6 py-2 max-md:w-full rounded-md bg-[#66B929] text-white font-bold block disabled:opacity-45"
              disabled={!isValid}
              onClick={onSendContactEmail}
            >
              {isSending && (
                <Spinner color="info" className="me-2" size={'sm'} />
              )}
              Send Message
            </button>
          </div>
        </div>
      </section>

      {/* <section className="py-4 space-y-4 font-nunito">
        <div className="flex justify-center">
          <img src={oasis} alt="" />
        </div>
        <h6 className="font-bold text-[#0098DB] text-center text-xl">
          Our Support
        </h6>
        <h5 className="font-bold text-[#0098DB] text-center text-4xl">
          Administrator Support & Access
        </h5>
        <div className="flex justify-center">
          <p className="w-[1000px] text-lg font-light text-center">
            Therapists, doctors, mentors, and other professionals who tested
            OASIS viability, found the platform very effective and enjoyable for
            all participants. By scheduling private peer support sessions,
            professionals have the ability to invite patients to a one-on-one or
            group session in the VR world. Each VR session that is booked by a
            professional is private to ensure anonymity and closed off to other
            people in the world. Help our community of recovering addicts today.
          </p>
        </div>
      </section>
      <section className="font-nunito border border-y border-[#0098DB] py-5 mb-7">
        <div className="space-y-8">
          <h5 className=" font-bold text-4xl text-[#0098DB] text-center underline underline-offset-[15px] decoration-4">
            Send Us A Message
          </h5>
          <h6 className="text-[#0098DB] text-lg text-center">
            Send Us Any Questions Or Concerns
          </h6>
        </div>
        <div className="w-[644px] mx-auto grid grid-cols-2 gap-5 mt-5">
          <div>
            <input
              className="border-[#0098DB] border px-4 py-2 rounded-md w-full"
              placeholder="First Name"
            />
          </div>
          <div>
            <input
              className="border-[#0098DB] border px-4 py-2 rounded-md w-full"
              placeholder="Last Name"
            />
          </div>
          <div>
            <input
              className="border-[#0098DB] border px-4 py-2 rounded-md w-full"
              placeholder="Subject"
            />
          </div>
          <div>
            <input
              className="border-[#0098DB] border px-4 py-2 rounded-md w-full"
              placeholder="Email Address"
            />
          </div>
          <div className="col-span-2 ">
            <textarea
              className="border-[#0098DB] border px-4 py-2 rounded-md w-full"
              placeholder="Your Message"
              rows={5}
            ></textarea>
          </div>
          <div className="col-span-2">
            <button className="bg-[#0098DB] text-white text-lg w-full py-2 rounded-md">
              Contact
            </button>
          </div>
        </div>
      </section> */}
      <Modal
        show={showMessage}
        dismissible
        size={"md"}
        onClose={() => setShowMessage(false)}
      >
        <Modal.Body className="space-y-4 font-nunito">
          <h6 className="text-[#0098DB] text-xl font-bold text-center">
            Thank you for contacting us!
          </h6>
          <p className="font-normal text-center">
            We appreciate your interest in Serenaverse. We will get back in
            touch with you soon!
          </p>
        </Modal.Body>
        <Modal.Footer
          theme={{
            base: "flex justify-center py-3 border-0",
            popup: "border-0",
          }}
          className="font-nunito"
        >
          <button
            onClick={() => setShowMessage(false)}
            className="bg-[#66B929] rounded-md text-white px-8 py-2 font-bold text-lg disabled:opacity-45"
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
